<template>
  <div class="setting-item">
    <div class="alert alert-danger" role="alert">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: "error block",
  props: {
    error: {
      type: String,
      default: "props :error='Тут ошибка'",
    },
  },
};
</script>

<style>
</style>